import { render, staticRenderFns } from "./PatientIssuesCableProvider.vue?vue&type=template&id=ccbfb7b2&scoped=true&"
import script from "./PatientIssuesCableProvider.vue?vue&type=script&lang=js&"
export * from "./PatientIssuesCableProvider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbfb7b2",
  null
  
)

export default component.exports